<div class="flex h-[70vh] w-[70rem] flex-col gap-4" *transloco="let t">
  <div class="flex justify-end gap-2">
    <div class="flex gap-2 opacity-0" [ngClass]="{ 'opacity-100': asinSelection().length > 0 }">
      <IButton
        [label]="t('common.delete')"
        size="sm"
        color="red"
        icon="icon-[lucide--trash]"
        [loading]="deleteAsinLoading()"
        [disabled]="this.asinSelection().length === this.strategyAsins.length"
        (onClick)="deleteProductFromStrategy(this.asinSelection())"
      />
      <IButton
        [label]="t('common.move')"
        size="sm"
        color="white"
        icon="icon-[lucide--chevrons-right]"
        [disabled]="this.asinSelection().length === this.strategyAsins.length"
        (onClick)="moveProductsMainStrategy(this.asinSelection())"
      />
    </div>
    <IButton
      [label]="t('common.add')"
      size="sm"
      color="white"
      icon="icon-[lucide--plus]"
      [disabled]="modalData.isReadOnly"
      (onClick)="openAddProductModal()"
    />
  </div>

  <app-asin-selection
    class="min-h-0 flex-1"
    ineligibilityTag="SP"
    [customList]="strategyAsins"
    [readonly]="modalData.isReadOnly"
    [csvExport]="true"
    [withBulk]="true"
    [withGroupByParent]="false"
    [(selectedAsins)]="asinSelection"
  />

  <ng-template #addProductModal>
    <div class="flex h-[60vh] w-[50rem] flex-col gap-4">
      <app-asin-selection
        class="min-h-0 flex-1"
        ineligibilityTag="SP"
        [customList]="availableAsinsToAdd"
        [(selectedAsins)]="addAsinSelection"
      />
      <div class="flex justify-end gap-2">
        <IButton [label]="t('common.cancel')" color="white" (onClick)="addProductModalRef?.close()" size="sm" />
        <IButton
          [label]="saveAddAsinLabel()"
          [disabled]="this.addAsinSelection().length === 0"
          [loading]="addAsinLoading()"
          (onClick)="addProductsToStrategy()"
          size="sm"
        />
      </div>
    </div>
  </ng-template>
</div>
